import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import collectionService from "./collectionService";

const errMsg = (error) =>
  error.response?.data?.message || error.message || "Something went wrong";
const fail = (error, thunkAPI) =>
  thunkAPI.rejectWithValue(error.response?.data || { message: errMsg(error) });

export const fetchCollections = createAsyncThunk("collection/fetchAll", async (_, thunkAPI) => {
  try {
    return await collectionService.getAll();
  } catch (error) {
    return fail(error, thunkAPI);
  }
});

export const saveCollection = createAsyncThunk("collection/save", async (formData, thunkAPI) => {
  try {
    const res = await collectionService.save(formData);
    return res.data;
  } catch (error) {
    return fail(error, thunkAPI);
  }
});

export const deleteCollection = createAsyncThunk("collection/delete", async (position, thunkAPI) => {
  try {
    await collectionService.remove(position);
    return position;
  } catch (error) {
    return fail(error, thunkAPI);
  }
});

const collectionSlice = createSlice({
  name: "collection",
  initialState: {
    list: [],
    slots: {
      1: { label: "Left (tall)", width: 1842, height: 2304 },
      2: { label: "Middle top (wide)", width: 852, height: 460 },
      3: { label: "Middle bottom (wide)", width: 852, height: 460 },
      4: { label: "Right (tall)", width: 1080, height: 1080 },
    },
    isLoading: false,
    isSaving: false,
    isError: false,
    message: "",
    errors: {},
  },
  reducers: {
    clearCollectionError: (state) => {
      state.isError = false;
      state.message = "";
      state.errors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (s) => { s.isLoading = true; })
      .addCase(fetchCollections.fulfilled, (s, a) => {
        s.isLoading = false;
        s.list = a.payload.data || [];
        if (a.payload.slots) s.slots = a.payload.slots;
      })
      .addCase(fetchCollections.rejected, (s, a) => {
        s.isLoading = false; s.isError = true;
        s.message = a.payload?.message || "Failed to load collections";
      })

      .addCase(saveCollection.pending, (s) => { s.isSaving = true; s.isError = false; s.errors = {}; s.message = ""; })
      .addCase(saveCollection.fulfilled, (s, a) => {
        s.isSaving = false;
        const i = s.list.findIndex((x) => x.position === a.payload.position);
        if (i >= 0) s.list[i] = a.payload; else s.list.push(a.payload);
      })
      .addCase(saveCollection.rejected, (s, a) => {
        s.isSaving = false; s.isError = true;
        s.message = a.payload?.message || "Failed to save";
        s.errors = a.payload?.errors || {};
      })

      .addCase(deleteCollection.pending, (s) => { s.isSaving = true; s.isError = false; })
      .addCase(deleteCollection.fulfilled, (s, a) => {
        s.isSaving = false;
        s.list = s.list.filter((x) => x.position !== a.payload);
      })
      .addCase(deleteCollection.rejected, (s, a) => {
        s.isSaving = false; s.isError = true;
        s.message = a.payload?.message || "Failed to delete";
      });
  },
});

export const { clearCollectionError } = collectionSlice.actions;
export default collectionSlice.reducer;